<template>
  <div class="trigger-management">
    <div class="toolbar">
      <div class="toolbar-left">
        <span class="toolbar-tip">罚单变为已确责后，按违规小类下发培训。安全违章再按违章描述分别对应培训。</span>
      </div>
      <div class="toolbar-right">
        <el-button type="primary" @click="openCreate">
          <i class="el-icon-plus"></i>
          新增规则
        </el-button>
        <el-button @click="loadRules">
          <i class="el-icon-refresh"></i>
          刷新
        </el-button>
      </div>
    </div>

    <el-table :data="ruleList" v-loading="loading" stripe>
      <el-table-column label="违规项" min-width="240">
        <template slot-scope="scope">
          <el-tag v-for="key in scope.row.matchKeys" :key="key" size="mini" style="margin: 0 6px 6px 0">
            {{ key | enumTransfer(violateOpts) }}
          </el-tag>
          <div v-if="scope.row.wfmsList && scope.row.wfmsList.length" class="wfms-line">
            <el-tag v-for="item in scope.row.wfmsList" :key="item" size="mini" type="warning" style="margin: 0 6px 6px 0">
              {{ item }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="trainingTitle" label="培训任务" min-width="180" show-overflow-tooltip />
      <el-table-column label="完成时限" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.finishDays">下发后 {{ scope.row.finishDays }} 天</span>
          <span v-else class="text-muted">沿用任务时限</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.enabled ? 'success' : 'info'" size="mini">
            {{ scope.row.enabled ? "启用" : "停用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" class="danger-text" @click="removeRule(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="log-header">
      <span>下发记录</span>
      <el-select v-model="logStatus" clearable placeholder="全部状态" size="small" style="width: 140px" @change="loadLogs(1)">
        <el-option label="成功" value="SUCCESS" />
        <el-option label="失败" value="FAILED" />
        <el-option label="处理中" value="PROCESSING" />
      </el-select>
    </div>

    <el-table :data="logs" v-loading="logLoading" stripe>
      <el-table-column prop="punishBillId" label="罚单ID" width="90" />
      <el-table-column label="违规项" min-width="140">
        <template slot-scope="scope">
          <div>{{ scope.row.violateClassify2 | enumTransfer(violateOpts) }}</div>
          <div v-if="scope.row.wfms" class="wfms-line">{{ scope.row.wfms }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="trainingTitle" label="培训任务" min-width="160" show-overflow-tooltip />
      <el-table-column prop="driverId" label="司机ID" width="100" />
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="statusType(scope.row.status)" size="mini">{{ statusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="failReason" label="失败原因" min-width="180" show-overflow-tooltip />
      <el-table-column label="时间" width="170">
        <template slot-scope="scope">
          {{ (scope.row.updateTime || scope.row.createTime) | dateFormat("yyyy-MM-dd HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status !== 'SUCCESS'" type="text" size="small" @click="retryLog(scope.row)">
            重试
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager">
      <el-pagination background layout="total, prev, pager, next" :current-page="logPage.current"
        :page-size="logPage.size" :total="logPage.total" @current-change="loadLogs" />
    </div>

    <el-dialog :title="form.id ? '编辑触发规则' : '新增触发规则'" :visible.sync="dialogVisible" width="640px" @close="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px" size="small">
        <el-form-item label="违规大类">
          <el-select v-model="classify1" filterable placeholder="请选择大类" style="width: 100%" @change="onClassify1Change">
            <el-option v-for="item in violateTypeOpts" :key="item.value" :label="item.label" :value="String(item.value)" />
          </el-select>
        </el-form-item>
        <el-form-item label="违规小类" prop="matchKeys">
          <el-select v-model="currentClassify2" multiple filterable collapse-tags placeholder="请先选择大类" style="width: 100%"
            :disabled="!classify1" @change="onClassify2Change">
            <el-option v-for="item in filteredViolateOpts" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <div v-if="form.matchKeys.length" class="picked-keys">
            <el-tag v-for="key in form.matchKeys" :key="key" size="mini" closable style="margin: 6px 6px 0 0"
              @close="removeMatchKey(key)">
              {{ key | enumTransfer(violateOpts) }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item v-if="hasSafetyViolation" label="违章描述" prop="wfmsList">
          <el-select v-model="form.wfmsList" class="wfms-select" multiple filterable allow-create default-first-option
            collapse-tags placeholder="选择或输入违章描述" style="width: 100%">
            <el-option v-for="item in wfmsOptions" :key="item" :label="item" :value="item" :title="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="培训任务" prop="trainingId">
          <el-select v-model="form.trainingId" filterable placeholder="请选择培训任务" style="width: 100%">
            <el-option v-for="item in trainingOptions" :key="item.id" :label="item.title" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="完成时限" prop="finishDays">
          <el-input v-model="form.finishDays" clearable placeholder="不填则沿用任务时限" style="width: 220px">
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.enabled" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="200" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  listTrainingTriggerRules,
  saveTrainingTriggerRule,
  deleteTrainingTriggerRule,
  listTrainingTriggerLogs,
  retryTrainingTriggerLog,
  getTrainingList,
  listVehicleViolationWfms
} from "@/api";

const SAFETY_VIOLATION = "3-21";

function emptyForm() {
  return {
    id: null,
    matchKeys: [],
    wfmsList: [],
    trainingId: null,
    finishDays: "",
    enabled: true,
    remark: ""
  };
}

export default {
  name: "TriggerManagement",
  data() {
    return {
      loading: false,
      logLoading: false,
      saving: false,
      ruleList: [],
      logs: [],
      logStatus: null,
      logPage: {
        current: 1,
        size: 10,
        total: 0
      },
      trainingOptions: [],
      wfmsOptions: [],
      classify1: "",
      currentClassify2: [],
      dialogVisible: false,
      form: emptyForm(),
      formRules: {
        matchKeys: [{ type: "array", required: true, message: "请选择违规小类", trigger: "change" }],
        wfmsList: [{
          validator: (rule, value, callback) => {
            if (!this.form.matchKeys.includes(SAFETY_VIOLATION)) {
              callback();
              return;
            }
            if (!value || !value.length) {
              callback(new Error("请选择违章描述"));
              return;
            }
            callback();
          },
          trigger: "change"
        }],
        trainingId: [{ required: true, message: "请选择培训任务", trigger: "change" }],
        finishDays: [{
          validator: (rule, value, callback) => {
            if (value === "" || value === null || value === undefined) {
              callback();
              return;
            }
            if (!/^[1-9]\d*$/.test(String(value)) || Number(value) > 365) {
              callback(new Error("请填写 1 到 365 的整数"));
              return;
            }
            callback();
          },
          trigger: "blur"
        }]
      }
    };
  },
  computed: {
    ...mapState({
      violateOpts: (state) => state.enumMap["DRIVER_VIOLATE_OPT_TYPE"] || [],
      violateTypeOpts: (state) => state.enumMap["DRIVER_VIOLATE_TYPE"] || []
    }),
    filteredViolateOpts() {
      if (!this.classify1) {
        return [];
      }
      const prefix = this.classify1 + "-";
      return this.violateOpts.filter((item) => String(item.value).indexOf(prefix) === 0);
    },
    hasSafetyViolation() {
      return this.form.matchKeys.includes(SAFETY_VIOLATION);
    }
  },
  created() {
    this.loadRules();
    this.loadLogs(1);
    this.loadTrainings();
  },
  methods: {
    loadRules() {
      this.loading = true;
      listTrainingTriggerRules()
        .then((res) => {
          this.ruleList = res.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadLogs(page) {
      this.logLoading = true;
      this.logPage.current = page || 1;
      listTrainingTriggerLogs({
        current: this.logPage.current,
        size: this.logPage.size,
        status: this.logStatus || undefined,
        _hideLoading: true
      })
        .then((res) => {
          const data = res.data || {};
          this.logs = data.records || [];
          this.logPage.total = data.total || 0;
        })
        .finally(() => {
          this.logLoading = false;
        });
    },
    loadTrainings() {
      getTrainingList({
        page: { current: 1, size: 500 },
        param: {},
        _hideLoading: true
      }).then((res) => {
        this.trainingOptions = (res.data && res.data.records) || [];
      });
    },
    loadWfmsOptions() {
      listVehicleViolationWfms().then((res) => {
        const values = new Set([...(res.data || []), ...(this.form.wfmsList || [])]);
        this.wfmsOptions = Array.from(values).filter((item) => item);
      });
    },
    syncCurrentClassify2() {
      if (!this.classify1) {
        this.currentClassify2 = [];
        return;
      }
      const prefix = this.classify1 + "-";
      this.currentClassify2 = this.form.matchKeys.filter((key) => String(key).indexOf(prefix) === 0);
    },
    onClassify1Change() {
      this.syncCurrentClassify2();
    },
    onClassify2Change(values) {
      const prefix = this.classify1 + "-";
      const others = this.form.matchKeys.filter((key) => String(key).indexOf(prefix) !== 0);
      this.form.matchKeys = others.concat(values || []);
      if (!this.form.matchKeys.includes(SAFETY_VIOLATION)) {
        this.form.wfmsList = [];
      } else if (!this.wfmsOptions.length) {
        this.loadWfmsOptions();
      }
    },
    removeMatchKey(key) {
      this.form.matchKeys = this.form.matchKeys.filter((item) => item !== key);
      this.currentClassify2 = this.currentClassify2.filter((item) => item !== key);
      if (key === SAFETY_VIOLATION) {
        this.form.wfmsList = [];
      }
    },
    openCreate() {
      this.form = emptyForm();
      this.classify1 = "";
      this.currentClassify2 = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    openEdit(row) {
      const matchKeys = [...(row.matchKeys || [])];
      this.form = {
        id: row.id,
        matchKeys,
        wfmsList: [...(row.wfmsList || [])],
        trainingId: row.trainingId,
        finishDays: row.finishDays ? String(row.finishDays) : "",
        enabled: row.enabled !== false,
        remark: row.remark || ""
      };
      const firstKey = matchKeys[0] || "";
      this.classify1 = firstKey.indexOf("-") > 0 ? firstKey.slice(0, firstKey.indexOf("-")) : "";
      this.syncCurrentClassify2();
      if (matchKeys.includes(SAFETY_VIOLATION)) {
        this.loadWfmsOptions();
      }
      if (row.trainingId && !this.trainingOptions.some((item) => item.id === row.trainingId)) {
        this.trainingOptions.push({ id: row.trainingId, title: row.trainingTitle || row.trainingId });
      }
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = emptyForm();
      this.classify1 = "";
      this.currentClassify2 = [];
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saving = true;
        const payload = {
          ...this.form,
          finishDays: this.form.finishDays ? Number(this.form.finishDays) : null,
          wfmsList: this.form.matchKeys.includes(SAFETY_VIOLATION) ? this.form.wfmsList : []
        };
        saveTrainingTriggerRule(payload)
          .then(() => {
            this.$message.success("规则已保存");
            this.dialogVisible = false;
            this.loadRules();
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    removeRule(row) {
      this.$confirm("删除后，该违规项确责时不再自动下发培训。", "删除规则", { type: "warning" })
        .then(() => deleteTrainingTriggerRule(row.id))
        .then(() => {
          this.$message.success("已删除");
          this.loadRules();
        })
        .catch(() => {});
    },
    retryLog(row) {
      retryTrainingTriggerLog(row.id).then(() => {
        this.$message.success("已重新下发");
        this.loadLogs(this.logPage.current);
      });
    },
    statusText(status) {
      if (status === "SUCCESS") {
        return "成功";
      }
      if (status === "FAILED") {
        return "失败";
      }
      if (status === "PROCESSING") {
        return "处理中";
      }
      return status || "";
    },
    statusType(status) {
      if (status === "SUCCESS") {
        return "success";
      }
      if (status === "FAILED") {
        return "danger";
      }
      return "info";
    }
  }
};
</script>

<style lang="less" scoped>
.trigger-management {
  .toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .toolbar-tip {
    color: #909399;
    font-size: 13px;
  }

  .text-muted {
    color: #909399;
  }

  .danger-text {
    color: #f56c6c;
  }

  .log-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 28px 0 12px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .pager {
    margin-top: 12px;
    text-align: right;
  }

  .wfms-line {
    margin-top: 4px;
    color: #e6a23c;
    font-size: 12px;
    line-height: 1.4;
  }

  .picked-keys {
    line-height: 1;
  }

}
</style>
